import React, { useState } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import faRestRoom from 'assets/restroom-solid';
import faPeopleArrows from 'assets/people-arrows';
import { ADVANCED_CHART_TYPES } from '../../constants/chartsConstants';
import ChartDisplay from './chartDisplay';
import CustomIconToolTip from '../tooltip/customToolTip';

const ChartNavItem = ({
  icon,
  activeChart,
  setActiveChart,
  name,
  disabled,
  questionId,
}) => {
  let color = activeChart === name ? 'blue' : 'black';
  color = disabled ? 'grey' : color;
  const cursor = disabled ? 'cursor-not-allowed' : 'cursor-pointer';
  const target = `${name}-${questionId}`;
  const toolTipText = name.split('-').join(' ');

  const onClick = () => {
    if (disabled) return;
    setActiveChart(name);
  };

  return (
    <CustomIconToolTip
      icon={icon}
      onClick={onClick}
      iconClassName={cursor}
      color={color}
      target={target}
      toolTipText={toolTipText}
      tooltipClassName="text-capitalize"
      placement="top"
    />
  );
};

const ChartNav = ({
  toggleChartReport,
  activeChart,
  setActiveChart,
  isSurveyTemplateQuestion,
  questionId,
}) => {
  const disabled = !isSurveyTemplateQuestion;

  return (
    <div
      style={{ cursor: 'default' }}
      className="w-100 d-flex justify-content-between py-2 pl-3 border rounded"
      onClick={e => e.stopPropagation()}
      role="none"
    >
      <div>
        <ChartNavItem
          icon="users"
          name={ADVANCED_CHART_TYPES.DEMOGRAPHICS}
          activeChart={activeChart}
          setActiveChart={setActiveChart}
          questionId={questionId}
        />
        <ChartNavItem
          icon="chart-line"
          name={ADVANCED_CHART_TYPES.PARTICIPANTS_OVERTIME}
          activeChart={activeChart}
          setActiveChart={setActiveChart}
          questionId={questionId}
        />
        <ChartNavItem
          icon="exchange-alt"
          name={ADVANCED_CHART_TYPES.CATEGORY_COMPARISION}
          activeChart={activeChart}
          setActiveChart={setActiveChart}
          disabled={disabled}
          questionId={questionId}
        />
        <ChartNavItem
          icon={faRestRoom}
          name={ADVANCED_CHART_TYPES.GENDER_COMPARISION}
          activeChart={activeChart}
          setActiveChart={setActiveChart}
          disabled={disabled}
          questionId={questionId}
        />
        <ChartNavItem
          icon={faPeopleArrows}
          name={ADVANCED_CHART_TYPES.AGE_GROUP_COMPARISION}
          activeChart={activeChart}
          setActiveChart={setActiveChart}
          disabled={disabled}
          questionId={questionId}
        />
        <ChartNavItem
          icon="user-clock"
          name={ADVANCED_CHART_TYPES.AGE_GROUP_ANSWERS}
          activeChart={activeChart}
          setActiveChart={setActiveChart}
          questionId={questionId}
        />
        <ChartNavItem
          icon="venus-mars"
          name={ADVANCED_CHART_TYPES.GENDER_ANSWERS}
          activeChart={activeChart}
          setActiveChart={setActiveChart}
          questionId={questionId}
        />
      </div>
      <div>
        <FontAwesomeIcon
          className="cursor-pointer"
          onClick={toggleChartReport}
          icon="times-circle"
        />
      </div>
    </div>
  );
};

const AdvancedReport = ({
  toggleChartReport,
  advancedReportVisible,
  questionId,
  dateRange,
  isSurveyTemplateQuestion,
}) => {
  if (advancedReportVisible) {
    const [activeChart, setActiveChart] = useState(
      ADVANCED_CHART_TYPES.DEMOGRAPHICS
    );

    return (
      <div className="px-3">
        <ChartNav
          toggleChartReport={toggleChartReport}
          activeChart={activeChart}
          setActiveChart={setActiveChart}
          isSurveyTemplateQuestion={isSurveyTemplateQuestion}
          questionId={questionId}
        />
        <ChartDisplay
          activeChart={activeChart}
          questionId={questionId}
          dateRange={dateRange}
        />
      </div>
    );
  }

  return (
    <div className="row px-3 pt-2 ml-0">
      <div
        className="d-flex align-items-center border p-1 px-2 cursor-pointer"
        onClick={toggleChartReport}
        role="none"
      >
        <FontAwesomeIcon
          className="mr-1"
          size="lg"
          icon="chart-pie"
          color="#29508B"
        />
        <span className="text-muted">Advanced Reporting</span>
      </div>
    </div>
  );
};

export default AdvancedReport;



// WEBPACK FOOTER //
// ./src/components/advancedReport/advancedReport.js